const DataSkyeLogo = () => {
  return (
    <div className="fixed bottom-6 right-6 z-[1000]">
      <a href="https://dataskye.com" target="_blank" rel="noopener noreferrer">
        <img
          src="/dataskye-logo.png"
          alt="DataSkye"
          className="h-8 opacity-80 hover:opacity-100 transition-opacity"
        />
      </a>
    </div>
  );
};

export default DataSkyeLogo;
